import Layout from '@/layout'

export default [
  {
    path: '/finance',
    name: 'Finance',
    component: Layout,
    redirect: '/finance/orderList',
    meta: { title: '财务管理', icon: 'el-icon-menu' },
    children: [
      {
        path: 'orderList',
        name: 'OrderList',
        component: () => import('@/views/finance/Order/orderList'),
        meta: { title: '订单管理' },
      },
      {
        path: 'detail',
        name: 'Detail',
        hidden: true,
        component: () => import('@/views/finance/Order/detail'),
        meta: { title: '订单详情' },
      },
      {
        path: 'withdrawal',
        name: 'Withdrawal',
        hidden: true,
        component: () => import('@/views/finance/withdrawal'),
        meta: { title: '提现' },
      },
      {
        path: 'withdrawalProgress',
        name: 'WithdrawalProgress',
        hidden: true,
        component: () => import('@/views/finance/withdrawalProgress'),
        meta: { title: '提现进度' },
      },
      {
        path: 'withdrawalRecord',
        name: 'WithdrawalRecord',
        hidden: true,
        component: () => import('@/views/finance/withdrawalRecord'),
        meta: { title: '提现记录' },
      },
      {
        path: 'incomeList',
        name: 'IncomeList',
        component: () => import('@/views/finance/Income/incomeList'),
        meta: { title: '资金流水' },
      },
      {
        path: 'frozenDetail',
        name: 'FrozenDetail',
        component: () => import('@/views/finance/frozenDetail'),
        meta: { title: '冻结明细' },
      },
      {
        path: 'lookFrozenDetail',
        name: 'LookFrozenDetail',
        component: () => import('@/views/finance/lookFrozenDetail'),
        meta: { title: '冻结详情' },
      },
    ],
  },
]
